import { useMutation, useQueryClient } from "@tanstack/react-query"
import { contentControllerDeleteItem } from "@/shared/api/generated"
import type { ContentIdDto } from "@/shared/api/generated"
import { useContentCache } from "./queries"
import { indexDBService } from "../indexdb"
import { QUERY_KEYS } from "@/shared/constants"
import { activePlayer } from "../audio-engine"

export const useDeleteContentItem = (deletetinFromPlace: "library" | "archived") => {
	const contentCache = useContentCache()
	const queryClient = useQueryClient()


	const formMutation = useMutation({
		mutationFn: (dto: ContentIdDto) => contentControllerDeleteItem(dto),
		onSuccess: (_, dto) => {
			queryClient.removeQueries({ queryKey: QUERY_KEYS.CONTENT_BY_ID(dto.id) })
		}
	})


	const handleDelete = async (id: string) => {
		if (activePlayer.id === id) {
			activePlayer.stopAll()
		}
		indexDBService.deleteAudioPosition(id)
		await formMutation.mutateAsync({ id })
		await contentCache.invalidateLibraryActivePage(deletetinFromPlace === "library")
		await contentCache.invalidateLibraryArchivedPage(deletetinFromPlace === "archived")

	}

	return { handleDelete, isLoading: formMutation.isPending }
}
